var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"selection",attrs:{"rounded":""},on:{"click":_vm.goToGitHub}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-github")]),_vm._v(" Project's repository ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }